
// 外部加载
// <script src="//res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
let wx = window.wx;

//打包在项目中
// import "../TEMPLATE/jweixin-1.2.0";
// let wx = window.wx;


import {
    isOutNet
} from "D:/workspace/all_web/src/_cmm/js/util";
import ajax from "D:/workspace/all_web/src/cmm/mod/ajax";

var en = location.href.split('#')[0];
en = encodeURIComponent(en);
var rqUrl = "//cdn.yeapar.com/wxym_yp/servlet/jsapi?url=" + en + "&t=" + new Date().getTime();

if(isOutNet())
ajax(rqUrl, function (result) {

    // result.debug = true; // ================================生产环境中注释掉
    result.jsApiList = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage'
        // 'getRecorderManager',
        // 'startRecord',
        // 'stopRecord',
        // 'onVoiceRecordEnd',
        // 'playVoice',
        // 'pauseVoice',
        // 'stopVoice',
        // 'onVoicePlayEnd',
        // 'uploadVoice',
        // 'downloadVoice',
        // 'translateVoice'
    ];
    wx.config(result); // 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
});

var linkRoot = window.location.protocol+'//cdn.yeapar.com/igtea/';
var onShareObj0 = {
    title: "阳西县数字农业产业",
    desc: "茶叶产业园 - VR展示系统", //
    link: linkRoot + "index.html",
    imgUrl: linkRoot + "res/share.jpg"              // 必须要待协议名 http: 或者 https:
};  

var onShareObj = Object.assign({}, onShareObj0);
onShareObj.desc = onShareObj0.desc;

window.resetShare = function (url) {    
    if (url) {
        // alert(url);
        onShareObj0.link = url;
        onShareObj.link = url;
    }

    wx.onMenuShareTimeline(onShareObj0);
    wx.onMenuShareAppMessage(onShareObj);
};
wx.ready(window.resetShare);
wx.error(function (res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    alert("error" + JSON.stringify(res));
});